import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '~/app/App'
import { USE_MOCKS } from '~/shared/config'

import '~/app/styles'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Не найден #root — index.html повреждён')
}

const root = createRoot(rootElement)

function render(): void {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

// Моки регистрируем ДО первого рендера, иначе первые запросы уйдут в сеть мимо реестра.
//
// Импорт обязан быть динамическим и обязан стоять под флагом. `~/app/mocks` статически тянет
// публичные API всех десяти слайсов — ему это положено, он в `app`, — но при статическом
// импорте отсюда весь их граф оказывался в бандле входа: флаг `USE_MOCKS` отсекал только
// ВЫЗОВ регистрации, а не ЗАГРУЗКУ модулей. Ценой были 13 чанков и 8 файлов стилей в
// `<link rel=modulepreload>`, то есть вся вёрстка приложения на критическом пути первого
// открытия — и это при том, что в проде моки не выполняются ни разу.
//
// В проде флаг сворачивается в `false` на этапе сборки, ветка становится мёртвой, и слайсы
// уходят из бандла входа целиком. Ветка `else` рендерит синхронно, лишнего тика нет.
if (USE_MOCKS) {
  void import('~/app/mocks').then(({ registerAllMocks }) => {
    registerAllMocks()
    render()
  })
} else {
  render()
}
